<template>
  <!-- Mission / Values / Culture（純 HTML + CSS 版） -->

  <!-- About Section Start -->
  <section class="d2c_about_wrapper d2c_props_bg position-relative">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-12">
          <!-- Tabs -->
          <ul class="nav mb-3 justify-content-start mv-tabs" role="tablist">
            <li class="nav-item" v-for="t in tabs" :key="t.id">
              <button
                class="nav-link"
                :class="{ active: activeTab === t.id }"
                type="button"
                role="tab"
                @click="activeTab = t.id"
              >
                {{ t.label }}
              </button>
            </li>
          </ul>

          <!-- Content -->
          <div class="tab-content">
            <div class="tab-pane fade show active">
              <div class="col-lg-8 offset-lg-2 text-center">
                <h4 class="d2c_sub_title">{{ currentTab.header.en }}</h4>
                <h2 class="d2c_title">{{ currentTab.header.zh }}</h2>
              </div>

              <p class="mv-paragraph">{{ currentTab.paragraph }}</p>

              <ul class="mv-bullets">
                <li v-for="(item, i) in currentTab.bullets" :key="i">
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- About Section End -->

  <!-- Values Section Start -->
  <section class="d2c_pricing_wrapper d2c_props_bg">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 text-center">
          <h4 class="d2c_sub_title">Our Values</h4>
          <h2 class="d2c_title">我們的核心價值</h2>
          <p class="mv-paragraph">
            我們的核心價值之一是專業，體現在專業知識與卓越品質、誠信與道德操守，以及以客戶為導向的服務方針上。
          </p>
        </div>
      </div>

      <ul class="row nav mb-4 mb-lg-5" id="pills-tab" role="tablist">
        <li class="col-5ths nav-item mb-4" role="presentation" >
          <button
            class="nav-link active" 
            id="pills-Professional-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-Professional"
            type="button"
            role="tab"
            aria-controls="pills-Professional"
            aria-selected="true"
          >
            <span class="d2c_btn_sub_title">Professional</span>
            <span class="mb-0 d2c_btn_title">專業知識</span>
          </button>
        </li>
        <li class="col-5ths nav-item mb-4" role="presentation">
          <button
            class="nav-link"
            id="pills-Activate-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-Activate"
            type="button"
            role="tab"
            aria-controls="pills-Activate"
            aria-selected="false"
          >
            <span class="d2c_btn_sub_title">Activate</span>
            <span class="mb-0 d2c_btn_title">激發潛能</span>
          </button>
        </li>
        <li class="col-5ths nav-item mb-4  pill-bk" role="presentation">
          <button
            class="nav-link"
            id="pills-Curiosity-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-Curiosity"
            type="button"
            role="tab"
            aria-controls="pills-Curiosity"
            aria-selected="false"
          >
            <span class="d2c_btn_sub_title">Curiosity</span>
            <span class="mb-0 d2c_btn_title">好奇探索</span>
          </button>
        </li>
        <li class="col-5ths nav-item mb-4" role="presentation">
          <button
            class="nav-link"
            id="pills-Elevate-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-Elevate"
            type="button"
            role="tab"
            aria-controls="pills-Elevate"
            aria-selected="false"
          >
            <span class="d2c_btn_sub_title">Outstanding</span>
            <span class="mb-0 d2c_btn_title">追求卓越</span>
          </button>
        </li>
        <li class="col-5ths nav-item mb-4" role="presentation">
          <button
            class="nav-link"
            id="pills-Future-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-Future"
            type="button"
            role="tab"
            aria-controls="pills-Future"
            aria-selected="false"
          >
            <span class="d2c_btn_sub_title">Future</span>
            <span class="mb-0 d2c_btn_title">塑造未來</span>
          </button>
        </li>
      </ul>
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-Professional"
          role="tabpanel"
          aria-labelledby="pills-Professional-tab"
        >
          <div class="d2c_pricing_details">
            <div class="row mb-4">
              <div class="col-12">
                <div class="d-flex flex-column gap-3">
                  <!-- 每一列一個小 row -->
                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">專業與卓越</h4>
                      <span class="text-muted">Expertise & Excellence</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content">提供最高標準的教育資源與專業服務。</span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">誠信與道德</h4>
                      <span class="text-muted">Integrity & Ethics</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content">在所有業務往來中保持誠實透明。</span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">客戶導向</h4>
                      <span class="text-muted">Customer-Oriented Service</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content"
                        >以客戶為導向專注於滿足客戶需求，提供客製化解決方案。</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <a href="./pages/contact.html" class="btn">Purchase now</a> -->
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="pills-Activate"
          role="tabpanel"
          aria-labelledby="pills-Activate-tab"
        >
          <div class="d2c_pricing_details">
            <div class="row mb-4">
              <div class="col-12">
                <div class="d-flex flex-column gap-3">
                  <!-- 每一列一個小 row -->
                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">主動積極</h4>
                      <span class="text-muted">Initiative & Proactivity</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content"
                        >我們鼓勵團隊成員主動尋找機會，積極解決問題，不斷推動創新與改進。</span
                      >
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">賦權與領導</h4>
                      <span class="">Empowerment & Leadership</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content"
                        >我們培養領導能力，賦予團隊成員權力和責任，使他們能夠自主決策並推動變革。</span
                      >
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">靈活應變</h4>
                      <span class="text-muted">Dynamic & Agile</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content"
                        >我們保持靈活性，能夠快速適應變化的環境和需求，提供動態的解決方案。</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="pills-Curiosity"
          role="tabpanel"
          aria-labelledby="pills-Curiosity-tab"
        >
          <div class="d2c_pricing_details">
            <div class="row mb-4">
              <div class="col-12">
                <div class="d-flex flex-column gap-3">
                  <!-- 每一列一個小 row -->
                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">持續學習</h4>
                      <span class="text-muted">Continuous Learning</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content"
                        >鼓勵終身學習的精神，不斷追求新知識和技能。</span
                      >
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">創新與創意</h4>
                      <span class="text-muted">Innovation & Creativity</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content">重視創新思維，尋找突破性的解決方案。</span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">開放心態</h4>
                      <span class="text-muted">Open-Mindedness</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content">保持開放的心態，接納不同觀點和想法。</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="pills-Elevate"
          role="tabpanel"
          aria-labelledby="pills-Elevate-tab"
        >
          <div class="d2c_pricing_details">
            <div class="row mb-4">
              <div class="col-12">
                <div class="d-flex flex-column gap-3">
                  <!-- 每一列一個小 row -->
                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">卓越表現</h4>
                      <span class="text-muted">Excellence in Performance</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content">在所有工作中追求最高標準。</span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">成長與進步</h4>
                      <span class="text-muted">Growth & Progress</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content">持續自我提升和專業發展。</span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">團隊協作</h4>
                      <span class="text-muted">Team Collaboration</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content">通過合作實現共同目標。</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="pills-Future"
          role="tabpanel"
          aria-labelledby="pills-Future-tab"
        >
          <div class="d2c_pricing_details">
            <div class="row mb-4">
              <div class="col-12">
                <div class="d-flex flex-column gap-3">
                  <!-- 每一列一個小 row -->
                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">前瞻領導力</h4>
                      <span class="text-muted">Visionary Leadership</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content">以遠見和策略思維引領教育發展方向。</span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">創新解決方案</h4>
                      <span class="text-muted">Innovative Solutions</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content">開發突破性的教育方法和工具。</span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 d-flex align-items-start">
                      <h4 class="mb-0 me-2">企業社會責任</h4>
                      <span class="text-muted">Corporate Responsibility</span>
                    </div>
                    <div class="col-md-6 d-flex align-items-start">
                      <i class="fas fa-check custom-check me-2 mt-1"></i>
                      <span class="text-content">致力於對社會和環境產生正面影響。</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Values Section End -->

  <!-- Our Culture Section Start -->
  <section class="d2c_features_wrapper">
    <div class="container">
      <div class="row">
        <div class="col-md-8 offset-md-2 text-center">
          <h4 class="d2c_sub_title">Our Culture</h4>
          <h2 class="d2c_title">我們的企業文化</h2>
          <p class="mv-paragraph">
            聯洋文化的企業文化建立在專業精神、創新思維與持續成長的基礎上。
          </p>
        </div>
        <div class="col-md-6 col-lg-4 mb-4 mb-lg-0">
          <div class="d2c_card_wrapper text-center">
            <img
              src="../assets/img-1/AboutUs/services_img_one.jpg"
              class="img-fluid"
              alt="Features Image"
            />
            <div class="d2c_card_body">
              <h4 class="d2c_card_title">專業創新的工作環境</h4>
              <p class="mb-0">
                我們營造積極主動、充滿活力的工作環境，鼓勵探索與創新，並持續追求卓越。我們的團隊致力於提供優質的外語學習資源與服務，支持從幼兒教育到高等教育的學習發展。
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-4 mb-lg-0">
          <div class="d2c_card_wrapper text-center">
            <img
              src="../assets/img-1/AboutUs/features_img_two.jpg"
              class="img-fluid"
              alt="Features Image"
            />
            <div class="d2c_card_body">
              <h4 class="d2c_card_title">合作與道德經營</h4>
              <p class="mb-0">
                我們堅信合作的力量與道德經營的重要性，並在所有業務往來中保持誠信與透明。我們擁抱多元文化，鼓勵開放心態，打造一個充滿活力的學習社群，讓創新思維蓬勃發展，並充分發揮每位成員的潛能。
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 offset-md-3 offset-lg-0">
          <div class="d2c_card_wrapper text-center">
            <img
              src="../assets/img-1/AboutUs/features_img_three.jpg"
              class="img-fluid"
              alt="Features Image"
            />
            <div class="d2c_card_body">
              <h4 class="d2c_card_title">塑造教育的未來</h4>
              <p class="mb-0">
                我們共同致力於塑造教育的未來——賦能教育者、啟發學習者，並創造長遠影響。在聯洋文化，我們不只是提供學習資源，更是在打造一個傳承知識與成長的教育願景。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Our Culture Section End -->
</template>

<script setup>
import { computed, ref } from 'vue'

const tabs = [
  { id: 'journey', label: 'Journey' },
  { id: 'vision',  label: 'Vision'  },
  { id: 'mission', label: 'Mission' },
]

const content = {
  journey: {
    header: { en: 'Our Journey', zh: '我們的歷程' },
    paragraph:
      '自 2002 年以來，聯洋文化一直是台灣值得信賴的教育資源經銷商，與國際知名出版商攜手合作，為教育工作者和學習者提供高品質的學習教材。我們致力於卓越教育，連結全球教育資源與在地機構，確保學習者能夠獲得創新且高效的學習方案。',
    bullets: [
      '● 創立｜2002 年聯洋文化成立，成為台灣外語教育資源經銷商。',
      '● 成長｜與國際知名出版商建立合作關係，提供高品質學習教材。',
      '● 發展｜連結全球外語教育資源與在地機構，提供創新學習方案。',
    ],
  },
  vision: {
    header: { en: 'Our Vision', zh: '我們的願景' },
    paragraph:
      '成為全球領先的創新外語學習資源與服務提供者，賦能教育機構培養求知精神，提升學術卓越，並塑造充滿無限可能的未來。',
    bullets: [
      '● 全球領先｜成為創新外語學習資源與服務的全球領導者。',
      '● 賦能教育｜培養求知精神，提升學術卓越。',
      '● 塑造未來｜創造充滿無限可能的教育未來。',
    ],
  },
  mission: {
    header: { en: 'Our Mission', zh: '我們的使命' },
    paragraph:
      '聯洋文化致力於透過戰略性採購高品質的外語學習資源，啟發學習潛能，涵蓋從幼兒園至大學的各個學習階段。我們提供教材採購、圖書館建置、教師培訓及教育顧問，推動好奇探索、專業精神與持續成長的文化，賦能教育工作者與學習者，推動教育的未來發展。',
    bullets: [
      '● 支持教育機構｜教材採購、圖書館建置、教師培訓與教育顧問諮詢。',
      '● 推動教育文化｜好奇探索、專業精神與持續成長。',
      '● 啟發學習潛能｜涵蓋幼兒園至大學的各個學習階段。',
      '● 發揮最大潛能｜賦能教育工作者與學習者，促進未來發展。',
    ],
  },
}

const activeTab = ref('journey')
const currentTab = computed(() => content[activeTab.value])
</script>


<style src="../assets/CSS/AboutDown.css" scoped></style>
